import { RootState } from 'types/store';

export const createProcessingSelector = (actions: string[]) => (state: RootState) => {
    // add another condition if I break something: action.indexOf('GET_') < 0 &&
    return actions.some((action) => state.loading[action]);
};
